import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FlightBookingDetails } from "../../Services/API";
import Header from '../../Components/Header';

const Thankyou = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    function getParamIgnoreCase(key) {
        for (const [k, v] of queryParams.entries()) {
            if (k.toLowerCase() === key.toLowerCase()) {
                return v;
            }
        }
        return null;
    }
    const referenceNo = getParamIgnoreCase("referenceNo");

    const [flightDetails, setFlightDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    useEffect(() => {
        if (referenceNo) {
            //console.log("referenceNo:", referenceNo);
            fetchFlightBookingDetails(referenceNo);
        } else {
            console.warn("Missing referenceNo");
        }
    }, [referenceNo]);

    const fetchFlightBookingDetails = async (referenceNo) => {
        //console.log(referenceNo);
        try {
            setLoading(true);
            setError("");
            const params = { ReferenceNo: referenceNo, TrackID: "", ClientCode: "BerryJourneys", Key: "", SessionID: "" };
            const response = await FlightBookingDetails(params);
            ////console.log("thanku response:", response);

            setFlightDetails(response);
            // if (response?.message === "Payment successful using Agency Wallet.") {
            //     setSuccess("Payment successful!!");

            // } else {
            //     setPaymentError(response?.message || "Payment fail. Try again.");
            // }

        } catch (err) {
            setError("Failed to load flight Booking details. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    let message;

    if (loading) {
        message = <h4 className="main-message">Loading booking details...</h4>;
    } else if (error) {
        message = <h4 className="main-message error">{error}</h4>;
    } else if (
        flightDetails &&
        flightDetails.airBookingResponse &&
        flightDetails.airBookingResponse[0]
    ) {
        const booking = flightDetails.airBookingResponse[0];
        if ((booking.ticketingStatus === "Confirmed" || booking.ticketingStatus === "Success") && booking.customerInfo?.payment?.paymentStatus === "Success") {
            message = (
                <div className="row">
                    <div className="col-sm-12 col-md-12 margin-bottom-10">
                        <div className="booking-information travelo-box">
                            <div className="row">
                                <div class="col-lg-6">
                                    <h6 className='ruler'>Booking Confirmation</h6>
                                </div>
                                <div class="col-lg-6 text-right">
                                    {/* <ul class="option_s">
                                    <li><a href="" data-bs-toggle="tooltip" data-bs-placement="top" title="Print Ticket"> <img src="/assets/images/printer.png" alt="train" /></a></li>
                                    <li><a href="" data-bs-toggle="tooltip" data-bs-placement="top" title="cancel Ticket"> <img src="/assets/images/cancel.png" alt="train" /></a></li>
                                    <li><a href="" data-bs-toggle="tooltip" data-bs-placement="top" title="PNR Status"><img src="/assets/images/ticket.png" alt="train" /></a></li>
                                    <li><a href="" data-bs-toggle="tooltip" data-bs-placement="top" title="Agency Invoice"><img src="/assets/images/Invoice.png" alt="train" /></a></li>
                                    <li><a href="" data-bs-toggle="tooltip" data-bs-placement="top" title="Customer Invoice"><img src="/assets/images/Invoice.png" alt="train" /></a></li>
                                    <li><a href="" data-bs-toggle="tooltip" data-bs-placement="top" title="File TDR Details"><img src="/assets/images/folder.png" alt="train" /></a></li>
                                </ul> */}
                                </div>
                                <div className="col-md-12 booking-confirmation clearfix">
                                    <i className="soap-icon-recommend icon circle"></i>
                                    <div className="message">
                                        <h4 className="main-message">
                                            Dear Customer,<br />
                                            Thank You. Your Booking Order is Confirmed Now.<br />
                                            A confirmation email has been sent to your provided email address.
                                        </h4>
                                        <p className="mt-3" style={{ color: "green" }}>Reference No: <strong>{booking.transactionID || flightDetails.referenceNo}</strong> </p>
                                    </div>
                                </div>
                            </div>


                            <h6 className='ruler'>Trip Information</h6>
                            {flightDetails.airBookingResponse?.map((response, index) => (
                                <div key={index} className="term-description">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Booking Status</th>
                                                <th>PNR</th>
                                                <th>Origin</th>
                                                <th>Destination</th>
                                                <th>Journey Date</th>
                                                <th>Adult</th>
                                                {response.child > 0 && (
                                                    <>

                                                        <th>Child</th>
                                                    </>
                                                )}

                                                {response.infant > 0 && (
                                                    <>

                                                        <th>Infant</th>
                                                    </>
                                                )}



                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td> {response.bookingStatus === "Confirmed" ? (
                                                    <span style={{ color: "green" }}>{response.bookingStatus}</span>
                                                ) : (
                                                    <span className="red">{response.bookingStatus}</span>
                                                )}</td>
                                                <td>{response.pnr}</td>
                                                <td>{response.origin}</td>
                                                <td>{response.destination}</td>
                                                <td> {new Date(response.flightDetails?.[0]?.departDateTime).toLocaleDateString(
                                                    "en-US",
                                                    {
                                                        weekday: "short",
                                                        month: "short",
                                                        day: "numeric",
                                                        year: "numeric",
                                                    }
                                                )}</td>
                                                <td>{response.adult}</td>
                                                {response.child > 0 && (
                                                    <td>
                                                        <>

                                                            {response.child}
                                                        </>
                                                    </td>
                                                )}
                                                {response.infant > 0 && (
                                                    <td>
                                                        <>

                                                            {response.infant}
                                                        </>
                                                    </td>
                                                )}





                                            </tr>
                                        </tbody>
                                    </table>
                                    {/* <dt>Booking Status</dt>
                                    <dd>
                                        {response.bookingStatus === "Confirmed" ? (
                                            <span style={{ color: "green" }}>{response.bookingStatus}</span>
                                        ) : (
                                            <span className="red">{response.bookingStatus}</span>
                                        )}
                                    </dd>

                                    <dt>PNR:</dt>
                                    <dd>{response.pnr}</dd>

                                    {response.tripType === "MultiCity" ? (
                                        response.flightDetails.map((seg, i) => (
                                            <React.Fragment key={i}>
                                                <dt>Origin:</dt>
                                                <dd>{seg.departAirportCode}</dd>
                                                <dt>Destination:</dt>
                                                <dd>{seg.arrivalAirportCode}</dd>
                                                <dt>Journey Date:</dt>
                                                <dd>
                                                    {new Date(seg.departDateTime).toLocaleDateString("en-US", {
                                                        weekday: "short",
                                                        month: "short",
                                                        day: "numeric",
                                                        year: "numeric",
                                                    })}
                                                </dd>
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <>
                                            <dt>Origin:</dt>
                                            <dd>{response.origin}</dd>
                                            <dt>Destination:</dt>
                                            <dd>{response.destination}</dd>
                                            <dt>Journey Date:</dt>
                                            <dd>
                                                {new Date(response.flightDetails?.[0]?.departDateTime).toLocaleDateString(
                                                    "en-US",
                                                    {
                                                        weekday: "short",
                                                        month: "short",
                                                        day: "numeric",
                                                        year: "numeric",
                                                    }
                                                )}
                                            </dd>
                                        </>
                                    )}

                                    <dt>Adult:</dt>
                                    <dd>{response.adult}</dd>

                                    {response.child > 0 && (
                                        <>
                                            <dt>Child:</dt>
                                            <dd>{response.child}</dd>
                                        </>
                                    )}

                                    {response.infant > 0 && (
                                        <>
                                            <dt>Infant:</dt>
                                            <dd>{response.infant}</dd>
                                        </>
                                    )}

                                    <dd>
                                        <a
                                            className="print-button button btn-small"
                                            title="Click here for Booking Detail"
                                            href={`/Reservations/Flight/TransactionDetails?referenceNo=${flightDetails.referenceNo}`}
                                        >
                                            Booking Detail
                                        </a>
                                    </dd> */}
                                </div>
                            ))}

                            <h6 className='ruler'>Flight Details</h6>
                            <div className="term-description">
                                <table class="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <th>Sector</th>
                                            <th>Airline</th>
                                            <th>Flight No.</th>
                                            <th>From / Terminal </th>
                                            <th>To / Terminal</th>
                                            <th>Dep Time</th>
                                            <th>Arr Time</th>
                                        </tr>
                                        {flightDetails?.airBookingResponse?.map((bookingResponse, bookingIndex) => (
                                            bookingResponse?.flightDetails?.map((flight, flightIndex) => (
                                                <tr key={`${bookingIndex}-${flightIndex}`}>
                                                    <td>{flight.departAirportCode} - {flight.arrivalAirportCode}</td>
                                                    <td>{flight.airLineName}</td>
                                                    <td>{flight.airLineCode} - {flight.flightNumber}</td>
                                                    <td class="dropdown-caps">{flight.departAirportCode} <span> :{flight.departTerminal}</span></td>
                                                    <td class="dropdown-caps">{flight.arrivalAirportCode} <span> :{flight.arrivalTerminal}</span></td>
                                                    <td>
                                                        {new Date(flight.departDateTime).toLocaleString("en-GB", {
                                                            weekday: "short",
                                                            day: "2-digit",
                                                            month: "short",
                                                            year: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                        })}
                                                    </td>
                                                    <td>
                                                        {new Date(flight.arrivalDateTime).toLocaleString("en-GB", {
                                                            weekday: "short",
                                                            day: "2-digit",
                                                            month: "short",
                                                            year: "numeric",
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                        })}
                                                    </td>
                                                </tr>
                                            ))
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <h6 className='ruler'>Traveler Information</h6>
                            {booking.customerInfo?.passengerDetails?.length > 0 && (
                                <div className="term-description">

                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Sr.No</th>
                                                <th>Traveler Name</th>
                                                <th>Contact Number</th>
                                                <th>Email ID</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {booking.customerInfo.passengerDetails.map((pax, i) => (
                                                <tr>
                                                    <td>{i + 1}</td>
                                                    <td>{pax.firstName} {pax.lastName}</td>
                                                    <td>{booking.customerInfo.mobile}</td>
                                                    <td>{booking.customerInfo.email}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>


                                </div>
                            )}


                            <h6 className='ruler'>Payment Information</h6>

                            {booking.customerInfo?.payment && (
                                <div className="term-description">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Payment Status</th>
                                                <th>Payment Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ color: "red" }}>{booking.customerInfo.payment.paymentStatus}</td>
                                                <td><i className="fa fa-inr"></i> {Math.round(booking.customerInfo.payment.amountPaid * 100) / 100}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>

                            )}

                            <input
                                type="hidden"
                                id="SearchId"
                                value={flightDetails.airBookingResponse?.[0]?.sessionID || ""}
                            />
                            <input
                                type="hidden"
                                id="BookingRefNo"
                                value={flightDetails.referenceNo || ""}
                            />

                            <div id="SetInsuranceDetails" className="hidden"></div>
                        </div>
                    </div>
                </div>
            );
        }else if ((booking.bookingStatus == "Confirmed" && booking.ticketingStatus == "OnRequest") && booking.customerInfo?.payment?.paymentStatus === "Success") {
            message = (
                <div className="row">
                    <div className="col-md-12">
                        <div className="booking-information travelo-box">
                            <h2>Booking Reference: {" "} {flightDetails?.transactionID || flightDetails?.referenceNo}</h2>
                            <div className="booking-confirmation clearfix">
                                <div className="message">
                                    <h4 className="main-message">
                                        Dear Customer,<br />
                                        Thank you for booking !!,
                                        You booking has been blocked successfully. Our travel experts will contact
                                        you shortly.
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            );
         } else if (booking.bookingStatus === "Hold" && booking.customerInfo?.payment?.paymentStatus === "Unpaid") {
            message = (
                <>
                    {/* Booking Blocked Message */}
                    <div className="row">
                        <div className="col-sm-8 col-md-9 margin-bottom-10">
                            <div className="booking-information travelo-box">
                                <h2>
                                    Booking Blocked - Reference No:{" "}
                                    {flightDetails?.transactionID || flightDetails?.referenceNo}
                                </h2>

                                <div className="booking-confirmation clearfix">
                                    <i className="soap-icon-recommend icon circle"></i>
                                    <div className="message">
                                        <h4 className="main-message">
                                            Thank You. Your booking has been blocked successfully.
                                        </h4>
                                        <p>
                                            An email has been sent to your provided email address.
                                        </p>
                                    </div>
                                </div>

                                {/* Trip Information */}

                                <h2>Trip Information</h2>
                                {flightDetails.airBookingResponse.map((response, index) => (
                                    <dl
                                        key={index}
                                        className="term-description"
                                        style={{ textTransform: "none" }}
                                    >
                                        <dt>Booking Status</dt>
                                        <dd>
                                            <span className="red">{response.bookingStatus}</span>
                                        </dd>

                                        <dt>PNR:</dt>
                                        <dd>{response.pnr}</dd>

                                        {response.tripType === "MultiCity" ? (
                                            response.flightDetails.map((seg, i) => (
                                                <React.Fragment key={i}>
                                                    <dt>Origin:</dt>
                                                    <dd>{seg.departAirportCode}</dd>
                                                    <dt>Destination:</dt>
                                                    <dd>{seg.arrivalAirportCode}</dd>
                                                    <dt>Journey Date:</dt>
                                                    <dd>{new Date(seg.departDateTime).toDateString()}</dd>
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            <>
                                                <dt>Origin:</dt>
                                                <dd>{response.origin}</dd>
                                                <dt>Destination:</dt>
                                                <dd>{response.destination}</dd>
                                                <dt>Journey Date:</dt>
                                                <dd>
                                                    {new Date(
                                                        response.flightDetails[0].departDateTime
                                                    ).toDateString()}
                                                </dd>
                                            </>
                                        )}

                                        <dt>Adult:</dt>
                                        <dd>{response.adult}</dd>

                                        {response.child > 0 && (
                                            <>
                                                <dt>Child:</dt>
                                                <dd>{response.child}</dd>
                                            </>
                                        )}
                                        {response.infant > 0 && (
                                            <>
                                                <dt>Infant:</dt>
                                                <dd>{response.infant}</dd>
                                            </>
                                        )}

                                        <dd>

                                        </dd>
                                    </dl>
                                ))}

                                {/* Traveler Information */}
                                <hr />
                                <h2>Traveler Information</h2>
                                {booking.customerInfo?.passengerDetails?.length > 0 && (
                                    <dl
                                        className="term-description"
                                        style={{ textTransform: "none" }}
                                    >
                                        {booking.customerInfo.passengerDetails.map((pax, i) => (
                                            <React.Fragment key={i}>
                                                <dt>{i + 1}. Traveler name:</dt>
                                                <dd>
                                                    {pax.firstName} {pax.lastName}
                                                </dd>
                                            </React.Fragment>
                                        ))}
                                        <dt>Contact Number:</dt>
                                        <dd>{booking.customerInfo.mobile}</dd>
                                        <dt>Email id:</dt>
                                        <dd>{booking.customerInfo.email}</dd>
                                    </dl>
                                )}


                                <h2>Payment Information</h2>
                                {booking.customerInfo?.payment && (

                                    <div className="term-description">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Payment Status</th>
                                                    <th>Payment Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ color: "red" }}>{booking.customerInfo.payment.paymentStatus}</td>
                                                    <th><i className="fa fa-inr"></i>{Math.round(booking.customerInfo.payment.amountPaid * 100) / 100}</th>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            );
        } else if ((booking.ticketingStatus != "Confirmed" || booking.ticketingStatus != "Success") && booking.customerInfo?.payment?.paymentStatus === "Success") {
            message = (
                <div className="row">
                    <div className="col-md-12">
                        <div className="booking-information travelo-box">
                            <h2>Booking Reference: {" "} {flightDetails?.transactionID || flightDetails?.referenceNo}</h2>
                            <div className="booking-confirmation clearfix">
                                <div className="message">
                                    <h4 className="main-message">
                                        Dear Customer,<br />
                                        We received your payment, but due to a technical issue or fare change,
                                        your booking could not be processed. Our travel experts will contact
                                        you shortly.
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            );
        } else if ((booking.ticketingStatus != "Confirmed" || booking.ticketingStatus != "Success") && booking.customerInfo?.payment?.paymentStatus === "Failed") {
            message = (
                <div className="row">
                    <div className="col-md-12">
                        <div className="booking-information travelo-box">
                            <h2>Booking Reference: {" "} {flightDetails?.transactionID || flightDetails?.referenceNo}</h2>
                            <div className="booking-confirmation clearfix">
                                <div className="message">
                                    <h4 className="main-message">
                                        Dear Customer,<br />
                                        We did not received your payment. Due to a technical issue or fare change,
                                        your booking could not be processed. Our travel experts will contact
                                        you shortly.
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            );
        } else {
            message = <h4 className="main-message">No booking details found.</h4>;
        }

    } else {
        message = <h4 className="main-message">No booking details found.</h4>;
    }

    return (
        <>
            <Header></Header>
            <section className='Booking_flight'>
                <div className='container'>
                    <div className='box_shadow'>
                        <div className='col-md-12 col-lg-12'>
                            <div class="booking-confirmation clearfix">
                                <div className="message">{message}</div>

                            </div>
                        </div>

                        <div className="col-md-12 text-right">
                            <a className="redirect" title="Click here for Booking Detail"
                                href={`/Reservations/Flight/TransactionDetails?referenceNo=${flightDetails?.referenceNo || ""}`} >Booking Detail </a>

                            {/* </div></div></div>href={`/Reservations/Flight/TransactionDetails?referenceNo=${flightDetails.referenceNo || ""}`}> Booking Detail </a> */}
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
};

export default Thankyou;